import { Button, Card, Pagination, Table } from "antd";
import { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch } from "react-redux";
import ColVisibilityDropdown from "../../Shared/ColVisibilityDropdown";
import BulkDelete from "./BulkDelete";
import CrmSearch from "./CrmSearch";
import downloadLogo from "../../../assets/images/download-logo.svg";

const TableComponent = ({
  columns,
  list,
  csvList,
  loading,
  csvFileName,
  paginatedThunk,
  deleteManyThunk,
  children,
  handleSearch,
}) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const dispatch = useDispatch();

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const fetchData = (page, count) => {
    dispatch(paginatedThunk({ status: true, page, count }));
  };

  // Handle dynamic column visibility
  const [columnsToShow, setColumnsToShow] = useState(columns || []);

  useEffect(() => {
    setColumnsToShow(columns);
  }, [columns]);

  const columnsToShowHandler = (updatedColumns) => {
    setColumnsToShow(updatedColumns);
  };

  return (
    <>
      <Card className="mb-[16px] text-white table-card border-none border-radius-bottom">
        <div className="mb-2">
          <div className="w-full flex flex-col md:flex-row gap-2 items-center justify-between">
            <div className="flex flex-col sm:flex-row lg:items-center justify-between gap-2 w-full ">
              <div className="flex items-center gap-2">
                {!!selectedRowKeys.length && (
                  <BulkDelete
                    setSelected={setSelectedRowKeys}
                    selected={selectedRowKeys}
                    updateThunk={deleteManyThunk}
                    loadThunk={paginatedThunk}
                  />
                )}

                <Button className="btn-secondary">
                  <CSVLink
                    data={csvList ? csvList : list ? list : ""}
                    className="flex items-center gap-2 btn btn-dark btn-sm text-[10px] md:text-[14px]"
                    filename={csvFileName}
                  >
                    <img src={downloadLogo} />
                    Download CSV
                  </CSVLink>
                </Button>

                <ColVisibilityDropdown
                  options={columns}
                  columns={columns}
                  columnsToShowHandler={columnsToShowHandler}
                />
              </div>
              <div>
                <CrmSearch handleSearch={handleSearch} />
              </div>
            </div>
          </div>
        </div>

        <Table
          loading={loading}
          columns={columnsToShow}
          dataSource={list?.map((item) => ({
            ...item,
            key: item.id,
            id: item.id,
            name: item.name,
            contact: item.contact,
            numberOfParticipants: item.numberOfParticipants,
            bookingDate: item.bookingDate,
            finalAmount: item.finalAmount,
            transactionCode: item.transactionCode,
            paymentGateway: item.paymentGateway,
            franchiseName: item.user?.franchiseName || "N/A",
            gameName: item.product?.gameName || "N/A",
          }))}
          pagination={{
            defaultPageSize: 20,
            showSizeChanger: true, // Allow changing page size
            pageSizeOptions: ["10", "20", "50", "100"],
          }}
          scroll={{ x: 1000, y: window.innerHeight - 350 }}
          rowClassName={(record, index) =>
            index % 2 === 0 ? "even-row" : "odd-row"
          }
        />
      </Card>
      {children && children}
    </>
  );
};

export default TableComponent;
